import Navbar from './sections/navbar/Navbar';

import Home from './sections/home/Home';
import About from './sections/about/About';
import Contact from './sections/contact/Contact';
import Skill from './sections/Skills/Skill';

import Portfolio from './sections/project/Portfolio';
import Statistics from './sections/Github/Statistics';


import "./App.css"
import Footer from './sections/Footer/Footer';
// import Nav from './sections/floatingnav/Nav';



const App = () => {
 
  return (
    
    
    <main>
         

      <Navbar/>
     <Home/>
  
    <About/>
    <Skill/>
   <Portfolio/>
 
   <Statistics/>
   <Contact/>

    {/* <Nav/> */}
    <Footer/>
  

    </main>
  )
}

export default App






